const allBecomeMemberItems = document.querySelector('.become-member-extended__items');
if (allBecomeMemberItems) {
  const allBecomeMemberItemsLength = allBecomeMemberItems.querySelectorAll('.widget').length;
  if(allBecomeMemberItemsLength > 3) {
    allBecomeMemberItems.classList.add('_four')
  } else {
    allBecomeMemberItems.classList.add('_three')
  }
}
